import { type ReactNode } from "react";
import { Select, type SelectOptionType, type SelectProps } from "@onshopfront/components";
import { type MDBTypes, useMDBSelect } from "../../Utilities/Hooks/MDBHooks";

type ChangeCallback<TIsClearable extends boolean> = (
    value: (
        TIsClearable extends true ?
            (SelectOptionType<number> | null) :
            SelectOptionType<number>
    )
) => void;

interface Props<TIsClearable extends boolean> extends Omit<
    SelectProps<TIsClearable, false, number>,
    "defaultOptions" | "options" | "noOptionsMessage" | "value" | "onChange"
> {
    type: MDBTypes;
    mdbId: number | null;
    onChange: ChangeCallback<TIsClearable>;
}

/**
 * @deprecated Should just use the useMDBSelect hook instead
 */
export function MDBSelect<TIsClearable extends boolean>({
    type,
    mdbId,
    onChange,
    ...props
}: Props<TIsClearable>): ReactNode {
    const [ mdbRef, setMdbRef, loading, options ] = useMDBSelect<TIsClearable>(type, mdbId);

    return (
        <Select
            options={options}
            loading={loading}
            minimumSearchSize={3}
            value={mdbRef}
            onChange={option => {
                setMdbRef(option);
                onChange(option);
            }}
            {...props}
        />
    );
}
